/**
 * Convert backend production URLs to in-app relative links.
 *
 * Backend emits canonical production card URLs (shared with Telegram);
 * in the web app they must stay on the current origin so dev/preview
 * do not jump to production.
 */
export function toInAppCrmHref(href: string): string {
  try {
    const url = new URL(href);

    if (url.origin !== 'https://app.aigentos.tech') {
      return href;
    }

    // Check for card routes: /tasks/<id>, /deals/<id>, /contacts/<id>, etc.
    const cardMatch = url.pathname.match(/^\/([a-z]+)\/([A-Za-z0-9][A-Za-z0-9_-]{0,199})$/);
    if (cardMatch && cardMatch[1]) {
      const route = cardMatch[1];
      if (
        ['tasks', 'deals', 'contacts', 'companies', 'documents', 'meetings', 'projects'].includes(
          route,
        )
      ) {
        // Require empty search and hash
        if (url.search === '' && url.hash === '') {
          return url.pathname;
        }
      }
    }

    // Check for /chat?conversationId=<id>
    if (url.pathname === '/chat') {
      const params = url.searchParams;
      if (params.size === 1) {
        const conversationId = params.get('conversationId');
        if (
          typeof conversationId === 'string' &&
          /^[A-Za-z0-9][A-Za-z0-9_-]{0,199}$/.test(conversationId) &&
          url.hash === ''
        ) {
          return url.pathname + url.search;
        }
      }
    }

    return href;
  } catch {
    // URL parsing failed, return original
    return href;
  }
}
